import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'displayName',
})
export class DisplayNamePipe implements PipeTransform {
  transform(
    user:
      { displayName?: string; firstName?: string; lastName?: string; email?: string } | undefined,
    format: 'full' | 'short' = 'full'
  ): string {
    const fullName = this.getDisplayName(user);
    if (!fullName) return '';

    if (format === 'short') {
      const parts = fullName.split(/\s+/);
      if (parts.length >= 2) {
        return `${parts[0]} ${parts[1][0]}.`;
      }
    }

    return fullName;
  }

  private getDisplayName(
    user:
      { displayName?: string; firstName?: string; lastName?: string; email?: string } | undefined
  ): string {
    if (!user) return '';

    if (user.displayName) {
      return user.displayName;
    }

    const fullName = `${user.firstName ?? ''} ${user.lastName ?? ''}`.trim();
    if (fullName) {
      return fullName;
    }

    return user.email ?? '';
  }
}
